'use client';

import type { Tenant } from '@core/Entities/App/Tenants.entity';
import type { LocationAttrs } from '@core/Entities/Location/LocationAttr.entity';
import Button from '@gds/Button/Button';
import { Email } from '@gds/Icons/Paths/Email';

import type { PlpFiltersMessagesProps } from '../Filters/FilterPanel.entity';
import { useSavedSearchForm } from './UseSavedSearchForm';

import styles from './SavedSearchForm.module.css';

interface SavedSearchFilterCtaProps {
  strings: PlpFiltersMessagesProps;
  tenant?: Tenant;
  locationAttrs?: LocationAttrs;
}

export const SavedSearchFilterCta = ({
  strings,
  tenant,
  locationAttrs,
}: SavedSearchFilterCtaProps) => {
  const { openForm, canUseSavedSearch } = useSavedSearchForm({
    locale: 'uk',
    strings,
    locationAttrs,
  });

  return (
    <div className={`${styles.filterCtaWrapper} ${!canUseSavedSearch ? styles.noPadding : ''}`}>
      {canUseSavedSearch && (
        <Button
          leftIcon={<Email />}
          color={tenant === 'rac' ? undefined : 'secondary'}
          variant="outlined"
          onClick={openForm}
          fullWidth
        >
          {strings.createAlert}
        </Button>
      )}
    </div>
  );
};

SavedSearchFilterCta.displayName = 'SavedSearchFilterCta';
